import { useSelector } from "react-redux"
import { selectLoadingState } from "../../../../redux/customer"
import { PracticeStats } from "../types"
import { LoadingState } from "../../../../types"
import { Box, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material"

type PracticeStatsTableProps = {
  practiceStats: PracticeStats | null,
}

const PracticeStatsTable = (props: PracticeStatsTableProps) => {
  const { practiceStats } = props

  const loadingState = useSelector(selectLoadingState)
  const isLoaded = loadingState === LoadingState.Done && practiceStats

  return (
    <Table size="small" data-testid="stats-table">
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: '28%' }}>Category</TableCell>
          <TableCell align="center">Action Required</TableCell>
          <TableCell align="center">In Progress</TableCell>
          <TableCell align="center">Completed</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>OSHA</TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.osha.notStarted ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.osha.inProgress ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.osha.completed ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>HIPAA</TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.hipaa.notStarted ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.hipaa.inProgress ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.hipaa.completed ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Training Courses</TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.trainingCourses.notStarted ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.trainingCourses.inProgress ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {
                isLoaded
                  ? <> { practiceStats.trainingCourses.completed ?? 0 } </>
                  : <Skeleton width={24} height={23} variant="rounded" />
              }
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default PracticeStatsTable
